import { useDispatch, useSelector } from "react-redux";
import { selectLocale, setLocaleVal } from "store/localeSlice";
import logo from "image/logo.png"
import logoBlock from "image/logo-black.png"
import S1 from "image/S1.png"
import R1 from "image/R1.png"
import M1 from "image/M1.png"
import { Link, useLocation } from "react-router-dom";
import './header.less'
import { useEffect, useState } from "react";
import { BarsOutlined, CaretDownOutlined } from '@ant-design/icons';
import { Dropdown, MenuProps, Space } from "antd";
import { useIntl } from "react-intl";

export const Header = () => {
	const locale= useSelector(selectLocale);
	const intl = useIntl();
	const [isBlack, setIsBlack] = useState(false)
	// const [isBlack, setIsBlack] = useState(true)
	const location = useLocation()
	const dispatch = useDispatch()
	const [activeCla, setActiveCla] = useState('/Home')

	const [scrollPosition, setScrollPosition] = useState(0);

	const [isShowPro, setIsShowPro] = useState(false)
	// const menus = [{
	// 	key: '/Home',
	// 	label: 'Home'
	// }, {
	// 	key: '/Product',
	// 	label: 'Product'
	// }, {
	// 	key: '/News',
	// 	label: 'News'
	// }, {
	// 	key: '/BecomeADistributor',
	// 	label: 'Sales Support'
	// }, {
	// 	key: '/InstallationVideo',
	// 	label: 'After Sales'
	// }, {
	// 	key: '/AboutUs',
	// 	label: 'About Us'
	// }]
	const menus = [{
		key: '1',
		type: '/Home',
		label: <Link to='/Home'>{intl.formatMessage({id: 'header.menus.home'})}</Link>
	}, {
		key: '2',
		type: '/Product',
		label: <a>{intl.formatMessage({id: 'header.menus.product'})}</a>,
		children: [
			{
			  key: '2-1',
			  label: <Link to='/Product'>{intl.formatMessage({id: 'header.menus.proS1'})}</Link>,
			},
			{
			  key: '2-2',
			  label: <Link to='/ProductR1'>{intl.formatMessage({id: 'header.menus.proR1'})}</Link>,
			},
			{
				key: '2-3',
				label: <Link to='/ProductM1'>{intl.formatMessage({id: 'header.menus.proM1'})}</Link>,
			  },
		  ]
	}, {
		key: '3',
		type: '/News',
		label: <Link to='/News'>{intl.formatMessage({id: 'header.menus.news'})}</Link>
	}, {
		key: '4',
		type: '/BecomeADistributor',
		label: <Link to='/BecomeADistributor'>{intl.formatMessage({id: 'header.menus.support'})}</Link>
	}, {
		key: '5',
		type: '/InstallationVideo',
		label: <Link to='/InstallationVideo/video'>{intl.formatMessage({id: 'header.menus.after'})}</Link>
	}, {
		key: '6',
		type: '/AboutUs',
		label: <Link to='/AboutUs'>{intl.formatMessage({id: 'header.menus.about'})}</Link>
	}]
	const items: any = [
        
        {
            key: 'en',
            label: 'English',
          },
        // {
        //   key: 'zh_TW',
        //   label: '中文繁體'
        // },
        {
          key: 'ko',
          label: '한글',
        },
        {
          key: 'ja',
          label: '日本语',
        },
		{
			key: 'zh',
			label: '中文',
		}
      ];
	  const changeLanguage = (val: string) => {
        window.localStorage.setItem('_snailcle_web_locale_', val)
        dispatch<any>(setLocaleVal(val))
    }

	useEffect(() => {
		setActiveCla(location.pathname === '/' ? '/Home' : location.pathname)
		setIsBlack(location.pathname === '/' || location.pathname === '/Home' ? false : true)
		setIsShowPro(false)
	},[location])
	useEffect(() => {
		setIsBlack(activeCla === '/Home' ? false : true)
	},[activeCla])
	// useEffect(() => {
	// 	window.addEventListener('scroll', handleScroll);
		
	// 	return () => {
	// 	  window.removeEventListener('scroll', handleScroll);
	// 	};
	//   }, []);
	// const handleScroll = () => {
	// 	setScrollPosition(window.scrollY || document.documentElement.scrollTop);
	// };
	useEffect(() => {
		const handleScroll = () => {
			const position = window.scrollY;
			setScrollPosition(position);
		};
		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);
	return <div className={scrollPosition > 0 ?'scar-header-fixed-block' : 'scar-header-relative-block'}>
		<div className={isBlack||scrollPosition>0 ? 'black-menu scar-header' : 'scar-header'}>
			<div style={{flex: 1,height: '100%'}} className="pc-block">
			<Link to={'/Home'}>{isBlack ? <img style={{width: '112px'}} src={logoBlock}/> : <img style={{width: '112px'}} src={logo}/>}</Link>
				<ul className='scar-header-menus' onMouseLeave={() => {setIsShowPro(false)}}>
					{menus.map((item, index) =>  <li onMouseOver={() => {item.key==='2' && setIsShowPro(true);}} className={activeCla.indexOf(item.type) > -1 ? 'active': ''} key={index}>
						<span className="menu-title">{item.label}</span>
						{item.key === '2' && <div className={isShowPro ? 'showPro productor-wrapper' : "productor-wrapper"}>
							<div className={'productor-con-list'}>
								<Link to='/Product' className="product-con-item">
									<img className="pro-img" src={S1} alt="" />
									<p className="pro-title">{intl.formatMessage({id: 'header.menus.proS1'})}</p>
								</Link>
								<Link to='/ProductR1' className="product-con-item">
									<img className="pro-img" src={R1} alt="" />
									<p className="pro-title">{intl.formatMessage({id: 'header.menus.proR1'})}</p>
								</Link>
								<Link to='/ProductM1' className="product-con-item">
									<img className="pro-img" src={M1} alt="" />
									<p className="pro-title">{intl.formatMessage({id: 'header.menus.proM1'})}</p>
								</Link>
							</div>
						</div>}
					</li>)}
				</ul>
				
			</div>
			
			<div className="mobile-block">
				<Dropdown menu={{ items :menus }} trigger={['click', 'hover']}>
					<BarsOutlined style={{fontSize: 26}} />
				</Dropdown>
			</div>
			<div className="header-right-block">
				<Link className="where-to-buy-btn pc-1440-block" to="/WhereToBuy">{intl.formatMessage({id: 'wheretobuy.Btn'})}</Link>
				<Dropdown className="header-language-block" menu={{ items,onClick:e => changeLanguage(e.key) }}  trigger={['click', 'hover']}>
					<Space>
						{items.find((item:any) => item.key === locale)?.label}
						<CaretDownOutlined />
					</Space>
				</Dropdown>
				<div className="pc-1440-block-hidden"><Link className="where-to-buy-btn" to="/WhereToBuy">{intl.formatMessage({id: 'wheretobuy.Btn'})}</Link></div>
			</div>
			
		</div>
		<Link to={'/Home'} className="mobile-block logo-wrapper">{isBlack||scrollPosition>0 ? <img style={{width: '112px'}} src={logoBlock}/> : <img style={{width: '112px'}} src={logo}/>}</Link>
		{isBlack ? <div className="header-block"></div> : null}
	</div>
}